
import React, { useEffect } from 'react';
import ChatArea from '../../components/ChatArea';
import { Message, Dialect, Attachment, AppMode, Language, Conversation } from '../../types';
import { ChatService } from '../../api';
import { useDataTemplate } from '../../hooks/useDataTemplate';

interface ChatTemplateProps {
  messages: Message[];
  isLoading: boolean;
  onSendMessage: (content: string, attachments?: Attachment[]) => void;
  dialect: Dialect;
  mode: AppMode;
  isLiveActive?: boolean;
  setIsLiveActive?: (active: boolean) => void;
  voice: string;
  speechSpeed: number;
  language: Language;
  apiKey?: string;
  onOpenSettingsAt: (tab: 'profile' | 'app' | 'security') => void;
}

const ChatTemplate: React.FC<ChatTemplateProps> = (props) => {
  // We use useDataTemplate to fetch initial history if needed
  const { data: history } = useDataTemplate<Conversation[]>(ChatService.getHistory);

  useEffect(() => {
      // Logic to sync history if we wanted to replace App.tsx state completely
      if (history && history.length > 0) {
          // console.log("Chat History Loaded from API Gateway:", history);
      }
  }, [history]);

  return (
    <ChatArea 
      messages={props.messages}
      isLoading={props.isLoading}
      onSendMessage={props.onSendMessage}
      dialect={props.dialect}
      mode={props.mode}
      isLiveActive={props.isLiveActive}
      setIsLiveActive={props.setIsLiveActive}
      voice={props.voice}
      speechSpeed={props.speechSpeed}
      language={props.language}
      apiKey={props.apiKey}
      onOpenSettingsAt={props.onOpenSettingsAt}
    />
  );
};

export default ChatTemplate;
